import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSubjectList } from '@/api/modules/study.js';
import { activeUser } from '@/api/login';
export default {
  name: 'ActiveConfirm',
  props: {
    modalVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: this.modalVisible
    };
  },
  watch: {
    visible: function visible(val) {
      this.$emit('update:modalVisible', val);
    }
  },
  methods: {
    toggleVisible: function toggleVisible() {
      this.visible = !this.visible;
    },
    // 退出体验模式
    quitExperience: function quitExperience() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$activeUser, activeStatus, user, hasWriteInfo, userInfo, _yield$getSubjectList, status, message, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return activeUser();

              case 2:
                _yield$activeUser = _context.sent;
                activeStatus = _yield$activeUser.status;
                user = _yield$activeUser.data;

                if (!(activeStatus !== 1)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                hasWriteInfo = user.hasWriteInfo, userInfo = user.userInfo; // 存储用户信息

                localStorage.setItem('userInfo', JSON.stringify(userInfo)); // 未完善信息，直接跳到登陆页面完善信息

                if (!(hasWriteInfo !== 1)) {
                  _context.next = 14;
                  break;
                }

                sessionStorage.setItem('isPerfectInfo', true);

                _this.$router.push({
                  path: '/login'
                });

                _this.$store.dispatch('setUserMode', 'normal');

                return _context.abrupt("return");

              case 14:
                _context.next = 16;
                return getSubjectList({
                  edu: userInfo.edu || 3,
                  needAll: false
                });

              case 16:
                _yield$getSubjectList = _context.sent;
                status = _yield$getSubjectList.status;
                message = _yield$getSubjectList.message;
                data = _yield$getSubjectList.data;

                if (status === 1) {
                  // 设置成正常模式, 页面通过监听userMode重新获取数据
                  _this.$store.dispatch('setUserMode', 'normal');

                  if (data.length > 0) {
                    // 用户绑定过则直接弹激活窗口
                    _this.$emit('onUserBind');
                  } else {
                    // 没激活跳转到激活页面
                    _this.$router.push({
                      path: '/active'
                    });
                  } // 关闭确定弹窗


                  _this.toggleVisible();
                } else {
                  _this.$message.error(message);
                }

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};